import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
// import  'jquery/dist/jquery';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import App from './App';
import "./assets/scss/style.scss";
import store from "./Redux/Store";
// import * as serviceWorker from './serviceWorker';
import * as atatus from 'atatus-spa';
atatus.config('21332cead73347c7ae42047a8d2c6343').install();
ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>, 
    document.getElementById('root')
);

// serviceWorker.register();
